import type { ReactNode } from "react";
import { FaqListItem } from "../FaqListItem";
import "./ObjectionReasons.css";

type ObjectionReason = {
  title: string;
  description: string;
};

type ObjectionReasonsProps = {
  defaultExpandedIndex?: number;
  description?: ReactNode;
  expertImageUrls?: string[];
  heading?: ReactNode;
  objectionReasons: ObjectionReason[];
};

const defaultExpertImageUrls = [
  "https://cdn.shopify.com/s/files/1/0567/4365/7562/files/coach-matias.webp?v=1782996617",
  "https://cdn.shopify.com/s/files/1/0567/4365/7562/files/coach-niko.webp?v=1782996617",
  "https://cdn.shopify.com/s/files/1/0567/4365/7562/files/coach-christa.webp?v=1782996618",
  "https://cdn.shopify.com/s/files/1/0567/4365/7562/files/coach-gerhard.webp?v=1782996618",
];

export function ObjectionReasons({
  defaultExpandedIndex,
  description = "Entwickelt von unserem Team aus Rasenexperten.",
  expertImageUrls = defaultExpertImageUrls,
  heading = "Wir kümmern uns gern um deinen Rasen",
  objectionReasons,
}: ObjectionReasonsProps) {
  if (!objectionReasons.length) return null;

  return (
    <section className="react-pdp__onetime-objections">
      <div className="react-pdp__onetime-objections-header">
        <h2 className="react-pdp__onetime-objections-heading">
          {typeof heading === "string" ? <span>{heading}</span> : heading}
        </h2>
        <p className="react-pdp__onetime-objections-description">
          {description}
        </p>
        <div
          aria-label="Our lawn experts"
          className="react-pdp__onetime-objections-experts"
        >
          {expertImageUrls.map((imageUrl) => (
            <div
              className="react-pdp__onetime-objections-expert"
              key={imageUrl}
            >
              <img alt="" src={imageUrl} />
            </div>
          ))}
        </div>
      </div>

      <div className="react-pdp__onetime-objections-list">
        {objectionReasons.map((reason, index) => (
          <FaqListItem
            defaultExpanded={index === defaultExpandedIndex}
            description={reason.description}
            descriptionFormat="html"
            key={`${reason.title}-${index}`}
            title={reason.title}
          />
        ))}
      </div>
    </section>
  );
}
